import React from 'react';
import PropTypes from 'prop-types';
import OERIcon from '../Library/card/component/EventIcon';
import Grid from '@material-ui/core/Grid';
import MaterialCheckbox from '@material-ui/core/Checkbox';

import formatOERLabel from '../util/formatOERLabel';

export default class OerTriggerCheckbox extends React.Component {
  static propTypes = {
    oer: PropTypes.shape({ id: PropTypes.any.isRequired }).isRequired,
    handleOerChange: PropTypes.func.isRequired,
    handleOerTriggerChange: PropTypes.func.isRequired,
    oerChecked: PropTypes.bool.isRequired,
    triggerChecked: PropTypes.bool.isRequired,
    oerDisabled: PropTypes.bool.isRequired,
    triggerDisabled: PropTypes.bool.isRequired,
    systemId: PropTypes.string
  }

  static defaultProps = {
    systemId: 'peoplenet',
  }

  handleOerChange = oer => (event, value) => {
    this.props.handleOerChange(oer, event, value);
  }

  handleOerTriggerChange = oer => (event, value) => {
    this.props.handleOerTriggerChange(oer, event, value);
  }

  render() {
    const { oer, oerChecked, triggerChecked, systemId, oerDisabled, triggerDisabled } = this.props;

    return (
      <Grid item xs={12}>
        <Grid container spacing={0} justify="center" className="admin__checkbox admin__checkbox_oer-eventlist">
          <Grid item xs={1} className="admin__checkbox_icons">
            <div>
              <MaterialCheckbox disabled={triggerDisabled} checked={triggerChecked} id={oer.id + "_videosCheckbox"} onChange={this.handleOerTriggerChange(oer)} />
            </div>
          </Grid>
          <Grid item xs={1} className="admin__checkbox_icons">
            <div>
              <MaterialCheckbox disabled={oerDisabled} checked={oerChecked} id={oer.id + "_videosLibraryCheckbox"} onChange={this.handleOerChange(oer)} />
            </div>
          </Grid>
          <Grid item xs={10}>
            <div>
              <span className="admin__Label">
                <OERIcon triggerType={oer.id} eventType={oer.id} systemId={systemId} />  {formatOERLabel(oer.id)}
              </span>
            </div>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
